import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { CierresTab } from "./tabs/CierresTab";
import { ReajustesTab } from "./tabs/ReajustesTab";
import { InventarioInicialTab } from "./tabs/InventarioInicialTab";
import "./styles/InventarioBodega.css";

const TAB_CIERRES = "CIERRES";
const TAB_REAJUSTES = "REAJUSTES";
const TAB_INVENTARIO_INICIAL = "INVENTARIO_INICIAL";

class InventarioBodega extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva
        if (!tabFromUrl) {
            tabFromUrl = TAB_CIERRES;

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    navigateToCreacionCierre = () => {
        this.props.history.push(`/produccion-bodega/inventario/crear-cierre`);
    };

    render() {
        const { user } = this.props;

        const nombreUsuario = user ? user.nombre : "No definido";

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "92vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Inventario"
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent animated={false} />}
                    >
                        <TabPane tab="Cierres de inventario" key={TAB_CIERRES}>
                            <CierresTab
                                storageKey="prod_bod_cierres_inventario_state"
                                navigateToCreacionCierre={
                                    this.navigateToCreacionCierre
                                }
                            />
                        </TabPane>
                        <TabPane tab="Reajustes" key={TAB_REAJUSTES}>
                            <ReajustesTab storageKey="prod_bod_reajustes_inventario_state" />
                        </TabPane>
                        <TabPane
                            tab="Inventario inicial"
                            key={TAB_INVENTARIO_INICIAL}
                        >
                            <InventarioInicialTab
                                nombreUsuario={nombreUsuario}
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(InventarioBodega);
